var render, staticRenderFns
import script from "./BasicTabMixin.vue?vue&type=script&lang=js&"
export * from "./BasicTabMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45a76a7a')) {
      api.createRecord('45a76a7a', component.options)
    } else {
      api.reload('45a76a7a', component.options)
    }
    
  }
}
component.options.__file = "src/mixin/BasicTabMixin.vue"
export default component.exports